import { PropsWithChildren } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { Provider } from 'react-redux';

import { onSigninCallback, userManager } from '@/lib/auth';
import store from '@/stores/store';
import {
  AppPostHogProvider,
  AuthReduxSync,
  ProtectApp,
  SoftwareThemeProvider,
} from '@nablax/shared/components';
import { injectStore, wsInjectStore } from '@nablax/shared/lib';

injectStore(store);
wsInjectStore(store);

export const AppProviders = ({ children }: PropsWithChildren) => {
  return (
    <AppPostHogProvider>
      <Provider store={store}>
        <AuthProvider
          userManager={userManager}
          onSigninCallback={onSigninCallback}
        >
          <SoftwareThemeProvider>
            <AuthReduxSync />
            <ProtectApp>{children}</ProtectApp>
          </SoftwareThemeProvider>
        </AuthProvider>
      </Provider>
    </AppPostHogProvider>
  );
};
